import { useNavigate } from "react-router-dom";

const Disclaimer = () => {
  const navigate = useNavigate();
  return (
    <main className="dashboardLayoutSubSection rounded-xl">
      <section className="max-w-4xl mx-auto px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="bg-myButtonBg hover:bg-myLabelText cursor-pointer text-white px-6 py-2 rounded-md"
        >
          Back
        </button>
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          Disclaimer
        </h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Last Updated: 27th September, 2025
        </p>

        <p className="text-gray-600 mb-6">
          LLB360, a product of Saadruso Internet Media Pvt. Ltd., provides
          digital educational resources, mock tests, case studies, and learning
          tools designed to support students of law. By using our Services, you
          acknowledge and agree to the disclaimers set out below.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700">
          <li>
            <span className="font-semibold text-gray-800">
              Educational Purpose Only
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                All content, notes, case studies, and practice tests provided
                through LLB360 are for educational and informational purposes
                only.
              </li>
              <li>
                LLB360 is not a substitute for formal legal education,
                professional training, or legal advice.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              No Guarantee of Results
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                While we strive to provide accurate, updated, and exam-focused
                content, we do not guarantee:
              </li>
              <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
                <li>Academic performance or exam success.</li>
                <li>
                  Specific grades, ranks, or outcomes in university or bar
                  exams.
                </li>
                <li>Career opportunities, internships, or job placements.</li>
              </ul>
              <li>
                The responsibility for exam preparation and performance lies
                solely with the student.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Accuracy of Content
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                We make every effort to ensure that the study material is
                accurate and up to date.
              </li>
              <li>
                However, laws, case laws, and statutes are subject to
                amendments, judicial interpretations, and jurisdictional
                variations.
              </li>
              <li>
                Users are encouraged to cross-check references with official
                legal texts and university syllabi.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">No Legal Advice</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>LLB360 does not provide legal opinions or representation.</li>
              <li>
                Any examples, case briefs, or explanations provided are for
                learning purposes only and should not be relied upon as legal
                advice in real-world disputes or proceedings.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Third-Party Content
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Our platform may include references, links, or integrations to
                third-party resources.
              </li>
              <li>
                We are not responsible for the accuracy, reliability, or
                policies of such external resources.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Limitation of Liability
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                LLB360 and Saadruso Internet Media Pvt. Ltd. shall not be held
                liable for:
              </li>
              <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
                <li>Errors or omissions in the study material.</li>
                <li>
                  Student performance in academic or professional examinations.
                </li>
                <li>
                  Any loss, direct or indirect, arising from reliance on the
                  platform content.
                </li>
              </ul>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Updates to Disclaimer
            </span>
            <p className="mt-2 text-gray-600">
              We may revise this Disclaimer from time to time. Updated versions
              will be posted on this page with the “Last Updated” date.
              Continued use of the Services signifies acceptance of the revised
              Disclaimer.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Contact Us</span>
            <p className="mt-2 text-gray-600">
              For clarifications regarding this Disclaimer, please contact:
            </p>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Saadruso Internet Media Pvt Ltd.</li>
              <li>Email: contact@llb360.com</li>
              <li>Phone: 7673937360</li>
              <li>
                Address: Plot # 28, Doyens Township, Serilingampally, Hyderabad
                – 500 019
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </main>
  );
};

export default Disclaimer;
